module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_15_m.030829167a4c1ee2f4f4cc9e7f379253.png";